import React from 'react';
import styled from 'astroturf/react';

import { currentUser } from 'js/utils/user';

const SmallPremiumLockIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
  >
    <path d="M14.9997 6.66668H14.1663V5.00001C14.1663 2.70001 12.2997 0.833344 9.99967 0.833344C7.69967 0.833344 5.83301 2.70001 5.83301 5.00001V6.66668H4.99967C4.08301 6.66668 3.33301 7.41668 3.33301 8.33334V16.6667C3.33301 17.5833 4.08301 18.3333 4.99967 18.3333H14.9997C15.9163 18.3333 16.6663 17.5833 16.6663 16.6667V8.33334C16.6663 7.41668 15.9163 6.66668 14.9997 6.66668ZM12.583 6.66668H7.41634V5.00001C7.41634 3.57501 8.57467 2.41668 9.99967 2.41668C11.4247 2.41668 12.583 3.57501 12.583 5.00001V6.66668Z" />
  </svg>
);

const SmallOnly = styled.span`
  @import 'stylesheets/design_system/breakpoint';

  @include breakpoint(small, medium) {
    display: inline-flex;
  }

  @include breakpoint(large) {
    display: none;
  }
`;

const LargePremiumLockIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M18 8H17V6C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8ZM15.1 8H8.9V6C8.9 4.29 10.29 2.9 12 2.9C13.71 2.9 15.1 4.29 15.1 6V8Z" />
  </svg>
);

const LargeOnly = styled.span`
  @import 'stylesheets/design_system/breakpoint';

  @include breakpoint(small, medium) {
    display: none;
  }

  @include breakpoint(large) {
    display: inline-flex;
  }
`;

// "Reversed" in order because large icon is meant to show in full-screen navbar menu
// and small is meant to be inline in the denser navbar toolbar dropdown. This might
// need to be more configurable for future use cases.
const PremiumLock = () =>
  currentUser?.premium ? null : (
    <>
      <LargeOnly>
        <SmallPremiumLockIcon />
      </LargeOnly>
      <SmallOnly>
        <LargePremiumLockIcon />
      </SmallOnly>
    </>
  );

export default PremiumLock;
